// extracted by mini-css-extract-plugin
module.exports = {"eventDateRoot":"P16X9yY7","title":"bx1WiNFH","reported":"Y0h1s7T0","description":"i9VrBwIa"};